// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ee273eb9","453":"122cdcf1","455":"f7e06f09"}[chunkId] + ".chunk.js";
};